export enum ThrottleResult {
    Ok = 0,
    Quota = 1,
    Block = 2,
    Warn = 3
}
